import styled, {keyframes} from "styled-components";

// animation takes place in 10% of the time and the rest of 90% is waiting for the next iteration count
// example, if the animation if 7s long, 0.7s is the actual animation and the rest 6.3s is waiting
const scalingAnimation = keyframes`
    0% {
        transform: scale(0.95);
    }
    50% {
        transform: scale(1.1);
    }
    100% {
        transform: scale(0.95);
    }
`;

export const JackpotToastSuggestedGameDefaultBox = styled.div`
    width: 25%;
    flex: 0 1 auto;
    transform: scale(0.95);
    &:nth-child(1) {
        animation: ${scalingAnimation} 0.6s ease-in-out normal 1 forwards 1s;
    }
    &:nth-child(2) {
        animation: ${scalingAnimation} 0.6s ease-in-out normal 1 forwards 1.3s;
    }
    &:nth-child(3) {
        animation: ${scalingAnimation} 0.6s ease-in-out normal 1 forwards 1.6s;
    }
    &:nth-child(4) {
        animation: ${scalingAnimation} 0.6s ease-in-out normal 1 forwards 1.9s;
    }
`;